import React from "react";

interface AcademyIconProps {
  width?: string;
  height?: string;
  isActive?: boolean;
}

const AcademyIcon: React.FC<AcademyIconProps> = ({
  width = "24px",
  height = "22px",
  isActive = false,
}) => {
  const fillColor = `var(--${isActive ? "theme-primary-color" : "theme-inactive-color"})`;

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 420 240"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M221.378 200.3H168.528C168.328 200.3 168.138 200.3 167.948 200.29C155.878 200.1 144.588 193.53 138.448 183.11L112.428 138.94C105.988 128.01 105.988 114.42 112.428 103.49L138.448 59.3201C144.698 48.7101 156.228 42.1201 168.538 42.1201H221.388C233.698 42.1201 245.228 48.7101 251.478 59.3101L277.498 103.48C283.938 114.41 283.938 128 277.498 138.93L251.478 183.1C245.228 193.71 233.698 200.3 221.388 200.3H221.378ZM168.928 176.3H221.378C225.228 176.3 228.828 174.24 230.788 170.92L256.808 126.75C258.818 123.33 258.818 119.08 256.808 115.67L230.788 71.5001C228.828 68.1801 225.228 66.1201 221.378 66.1201H168.528C164.678 66.1201 161.078 68.1801 159.118 71.5001L133.098 115.67C131.088 119.09 131.088 123.33 133.098 126.75L159.118 170.92C161.058 174.2 164.618 176.26 168.418 176.29H168.928V176.3Z"
        style={{ fill: fillColor }}
      />
      <path
        d="M205.628 97.5601H184.268C182.348 97.5601 180.578 98.5701 179.608 100.22L169.028 118.18C168.028 119.87 168.028 121.98 169.028 123.67L179.608 141.63C180.578 143.28 182.358 144.29 184.268 144.29H205.628C207.548 144.29 209.318 143.28 210.288 141.63L220.868 123.67C221.868 121.98 221.868 119.87 220.868 118.18L210.288 100.22C209.318 98.5701 207.538 97.5601 205.628 97.5601Z"
        style={{ fill: fillColor }}
      />
      <path
        d="M34.4881 166.78C30.6381 166.78 26.8481 164.93 24.5381 161.5L7.57814 136.4C0.658142 126.16 -1.62186 114.15 1.14814 102.59C4.22814 89.77 13.0981 78.71 26.1381 71.44L121.408 14.55C138.608 5.03 158.758 0 179.688 0H214.968C221.598 0 226.968 5.37 226.968 12C226.968 18.63 221.598 24 214.968 24H179.688C162.888 24 146.818 27.96 133.198 35.46L37.9481 92.34C30.7781 96.31 25.9981 101.94 24.4981 108.2C23.2981 113.2 24.3281 118.31 27.4781 122.97L44.4381 148.07C48.1481 153.56 46.7081 161.02 41.2081 164.73C39.1481 166.12 36.8081 166.79 34.4981 166.79L34.4881 166.78Z"
        style={{ fill: fillColor }}
      />
      <path
        d="M217.038 239.45H174.318C167.688 239.45 162.318 234.08 162.318 227.45C162.318 220.82 167.688 215.45 174.318 215.45H217.038C233.438 215.45 249.118 211.7 262.388 204.6L355.348 150.66C362.288 146.93 366.868 141.69 368.258 135.9C369.318 131.46 368.348 126.89 365.438 122.71L348.888 98.9099C345.108 93.4699 346.448 85.9899 351.888 82.2099C357.328 78.4299 364.808 79.7699 368.588 85.2099L385.138 109.01C391.968 118.83 394.258 130.37 391.598 141.49C388.608 153.96 379.838 164.69 366.898 171.7L273.918 225.65C257.118 234.68 237.448 239.45 217.028 239.45H217.038Z"
        style={{ fill: fillColor }}
      />
    </svg>
  );
};

export default AcademyIcon;
